import { Dayjs } from "dayjs";

export interface Dispute {
    amount: number;
    status: DisputeStatus;
    chargebackFee: number;
    createdAt: Dayjs;
    resolvedAt?: Dayjs;
    amountReinstated?: number;
    amountWithdrawn?: number;
    stripeDestinationPayment?: string;
}

export enum DisputeStatus {
    PENDING = "pending",
    WON = "won",
}
